// @ts-nocheck
/* eslint-disable */
export const appChevronDown24Icon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M6.5 9.5L12 15.5L17.5 9.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'chevron-down-24' as const
};